// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spoink: PokeData = {
  "id": 325,
  "name": "spoink",
  "height": 7,
  "weight": 306,
  "base_experience": 66,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "confuse-ray",
    "psywave",
    "splash",
    "rest",
    "snore",
    "psych-up",
    "magic-coat",
    "odor-sleuth",
    "bounce",
    "payback",
    "power-gem",
    "zen-headbutt",
    "psyshock"
  ],
  "moves": [
    "growl",
    "psychic",
    "confuse-ray",
    "psywave",
    "splash",
    "zen-headbutt",
    "future-sight",
    "prismatic-cage",
    "psy-ball",
    "psychic-fangs",
    "psy-pulse",
    "synchronize",
    "calm-mind"
  ],
  "evolution_chain": {
    "id": 164,
    "item": null,
    "species": [
      {
        "name": "spoink",
        "order": 353,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grumpig",
        "order": 354,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 325,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 58.75,
    "speed": 60,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
